<template>
  <div class="d-flex align-items-center justify-content-center vh-100">
    <div class="text-center">
      <div v-if="loading" class="text-primary" role="status">
        <a-spin size="large" />
      </div>
      <div v-else-if="error" class="error-container">
        <div class="error-icon">
          <i class="fa fa-exclamation-circle"></i>
        </div>
        <h4 class="error-title">Authentication Error</h4>
        <p class="error-message">{{ error }}</p>
        <div class="error-actions">
          <button @click="retryLogin" class="btn btn-primary">
            <i class="fas fa-redo"></i> Try Again
          </button>
          <button @click="goToLogin" class="btn btn-outline-secondary">
            <i class="fas fa-sign-in-alt"></i> Go to Login
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import store from "store";
import router from "@/router";
import apiClient from "@/services/axios";
export default {
  name: "SSOLogin",
  data() {
    return {
      loading: true,
      error: null,
    };
  },
  async created() {
    try {
      await this.$store.dispatch("user/LOGOUT", true);
      const { token, userId } = this.$route.query;

      if (!token || !userId) {
        throw new Error("Missing token or userId");
      }

      this.$store
        .dispatch("user/SSO_LOGIN", { payload: { token, userId } })
        .then(async (user) => {
          /*if (user)
                this.$notification.success({
                  message: this.$t("login.connecte"),
                  description: this.$t("login.loginSuccess"),
                });*/
          await this.$store.commit("settings/CHANGE_SETTING", {
            setting: "activeBuilding",
            value: user.building[0].dbName,
          });
          if (user.building[0].base_url) {
            apiClient.defaults.baseURL = user.building[0].base_url + "/api/web";
            await this.$store.commit("settings/CHANGE_SETTING", {
              setting: "base_url",
              value: user.building[0].base_url,
            });
          }

          await this.$store.commit("settings/CHANGE_SETTING", {
            setting: "activeBuildingId",
            value: user.building[0]._id,
          });
          await this.$store.commit("settings/CHANGE_SETTING", {
            setting: "image",
            value: user.building.map((b) => {
              return {
                name: b.name,
                db: b.dbName,
                dbName: b.dbName,
                headMaster: b.headMaster,
                logo:
                  (b.base_url ? b.base_url : this.settings.base_url) +
                  "/" +
                  b.logo,
              };
            }),
          });
          await store.set("DB", user.building[0].dbName);
          store.set("app.topbar.favs", user.fav);
          apiClient
            .post("/schoolaryears/filter", {
              query: { $query: {}, $orderby: { end: -1 } },
            })
            .then(async (res) => {
              const data = res.data.map((sc) => {
                const start = new Date(sc["start"]);
                const end = new Date(sc["end"]);
                const startM =
                  start.getMonth() < 9
                    ? "0" + (start.getMonth() + 1)
                    : "" + (start.getMonth() + 1);
                const endM =
                  end.getMonth() < 9
                    ? "0" + (end.getMonth() + 1)
                    : "" + (end.getMonth() + 1);
                return {
                  ...sc,
                  name:
                    startM +
                    "-" +
                    start.getFullYear() +
                    " / " +
                    endM +
                    "-" +
                    end.getFullYear(),
                };
              });
              let activeSchoolarYearId = this.getCurrentScholarYearId(data);
              await this.$store.commit("settings/CHANGE_SETTING", {
                setting: "activeSchoolarYear",
                value: activeSchoolarYearId,
              });
              await this.$store.commit("settings/CHANGE_SETTING", {
                setting: "schoolarYears",
                value: data,
              });
              await store.set(
                "app.settings.activeSchoolarYear",
                activeSchoolarYearId
              );
              await store.set("activeSchoolarYear", activeSchoolarYearId);
              await store.set("SchoolarYear", activeSchoolarYearId);
              //get all routes
              let path = this.getFirstAcessPath(user.role.access);
              //FIXME why schooldetails.pack is undefined
              router.push(path);
            });
        })
        .catch((error) => {
          this.error = "Failed to login";
        })
        .finally(() => (this.loading = false));
    } catch (error) {
      this.error = error.message || "Failed to login";
    }
  },
  methods: {
    ...mapActions({
      setUserInfo: "user/setUserInfo",
      setAuthorized: "user/setAuthorized",
    }),
    getCurrentScholarYearId(schoolYears) {
      const currentDate = new Date();

      for (const schoolYear of schoolYears) {
        const startDate = new Date(schoolYear.start);
        const endDate = new Date(schoolYear.end);

        if (currentDate >= startDate && currentDate <= endDate) {
          return schoolYear._id;
        }
      }

      // If no matching school year is found, you can return null or handle it as needed.
      return schoolYears[0]._id;
    },
    getFirstAcessPath(access) {
      try {
        let firstAcess = {};
        let path = "";
        if (access.all === true || access.home === true) path = "/accueil";
        else {
          for (let key of Object.keys(access)) {
            if (access[key] === true || access[key].length > 0) {
              firstAcess = {
                key: key,
                role: Array.isArray(access[key])
                  ? access[key].filter((e) => e !== "all")
                  : access[key],
              };

              break;
            }
          }

          let routes = router.options.routes[0].children;
          path = routes.find(
            (e) =>
              (e.meta.accessGroup == firstAcess.key &&
                e.meta.roles.includes(firstAcess.role[0])) ||
              (e.meta.accessGroup == firstAcess.key && firstAcess.role === true)
          ).path;
        }
        return path;
      } catch (error) {
        return "/profile";
      }
    },
    retryLogin() {
      this.loading = true;
      this.error = null;
      window.location.reload();

      // Add your retry login logic here
    },
    goToLogin() {
      this.$router.push("/auth/login");
    },
  },
};
</script>

<style scoped>
.error-container {
  background: #fff;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  margin: 0 auto;
}

.error-icon {
  font-size: 3rem;
  color: #dc3545;
  margin-bottom: 1rem;
}

.error-title {
  color: #dc3545;
  margin-bottom: 1rem;
  font-weight: 600;
}

.error-message {
  color: #6c757d;
  margin-bottom: 1.5rem;
  line-height: 1.5;
}

.error-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
}

.btn {
  padding: 0.5rem 1rem;
  border-radius: 4px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.btn-primary {
  background-color: #007bff;
  border-color: #007bff;
  color: white;
}

.btn-outline-secondary {
  border-color: #6c757d;
  color: #6c757d;
}

.btn:hover {
  opacity: 0.9;
}
</style>
